import { defineNuxtPlugin } from '#app';
import sanitizeModelDirective from '~/directives/sanitizeModel';

export default defineNuxtPlugin((nuxtApp) => {
  // Register the directive globally
  nuxtApp.vueApp.directive('sanitize-model', sanitizeModelDirective);
});
